import { render, staticRenderFns } from "./CbsOrderSpec.vue?vue&type=template&id=456f65fa&scoped=true"
import script from "./CbsOrderSpec.vue?vue&type=script&lang=js"
export * from "./CbsOrderSpec.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456f65fa",
  null
  
)

export default component.exports